import { render, staticRenderFns } from "./ActionItem.pug?vue&type=template&id=6da6c655&lang=pug&"
import script from "./ActionItem.vue?vue&type=script&lang=js&"
export * from "./ActionItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports